import { generateClient } from "aws-amplify/api";
import { edit_user } from "@/graphql/mutations";
import store from "@/store";
import { clearAuthAndRedirect, ensureAuthSession } from "@/utils/authSession";

const client = generateClient();

const ONE_HOUR = 60 * 60 * 1000;
const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];

export function startIdleTimer(router) {
  let loggingOut = false;

  const setLastActive = () => {
    localStorage.setItem("lastActiveTime", Date.now());
  };

  const checkIdle = async () => {
    const last = Number(localStorage.getItem("lastActiveTime"));
    const now = Date.now();

    if (!last || now - last <= ONE_HOUR || loggingOut) {
      return;
    }

    loggingOut = true;
    console.log("Session expired due to inactivity");

    try {
      const hasSession = await ensureAuthSession({ forceRefresh: false });
      if (hasSession) {
        await client.graphql({
          query: edit_user,
          variables: {
            input: {
              is_logout_attempt: true,
              updating_user_id: store.state.currentUser?.user_id || "",
            },
          },
        });
      }
    } catch (error) {
      console.error("Idle logout update failed:", error);
    }

    localStorage.removeItem("lastActiveTime");
    await clearAuthAndRedirect(router);
    loggingOut = false;
  };

  const activityHandler = () => {
    setLastActive();
  };

  events.forEach((event) => window.addEventListener(event, activityHandler));

  document.addEventListener("visibilitychange", async () => {
    if (document.hidden) return;
    // Refresh tokens when the tab becomes active again so the next API call works.
    await ensureAuthSession({ forceRefresh: true });
    checkIdle();
  });

  setLastActive();

  const interval = setInterval(checkIdle, 60000);

  return () => {
    events.forEach((event) =>
      window.removeEventListener(event, activityHandler)
    );
    clearInterval(interval);
  };
}
